import { combineEpics } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { isActionOf } from 'typesafe-actions';

import { requestAccountInfoAsyncAction, selectSelectedProvider } from 'rdx/account';
import { GlobalAppActions } from 'rdx/actions';
import { AppServices } from 'rdx/middleware';
import { GlobalAppState } from 'rdx/state';
import { setDeviceType } from 'rdx/theme/actions';
import { selectDeviceType } from 'rdx/theme/selectors';

import { requestTargetingParametersAsyncAction } from './actions';

const requestTargetingDeviceTypeDependencies = (action$: Observable<GlobalAppActions>): any => {
  return action$.pipe(
    filter(isActionOf([requestAccountInfoAsyncAction.success, setDeviceType])),
    switchMap(() => {
      return of(requestTargetingParametersAsyncAction.request());
    }),
  );
};

const requestTargetingParametersEpic = (
  action$: Observable<GlobalAppActions>,
  state$: Observable<GlobalAppState>,
  { apiClient }: AppServices,
): Observable<GlobalAppActions> => {
  return action$.pipe(
    filter(isActionOf(requestTargetingParametersAsyncAction.request)),
    withLatestFrom(state$),
    switchMap(([, newState]) => {
      const selectedProvider = selectSelectedProvider(newState);
      const deviceType = selectDeviceType(newState);

      if (!selectedProvider?.providerId) {
        return of(
          requestTargetingParametersAsyncAction.failure(new Error('Missing selected provider id')),
        );
      }

      return from(
        apiClient.portal.getTargetingValuesForProvider({
          provider_id: selectedProvider.providerId,
          city_id: selectedProvider.cityId,
          country_code: selectedProvider.countryCode,
          signup_source: selectedProvider.signup_source,
          provider_status: selectedProvider.lifecycle_status,
          device_type: deviceType,
        }),
      ).pipe(
        map((response) => requestTargetingParametersAsyncAction.success(response)),
        catchError((err) => of(requestTargetingParametersAsyncAction.failure(err))),
      );
    }),
  );
};

export const targetingParametersEpic = combineEpics(
  requestTargetingDeviceTypeDependencies,
  requestTargetingParametersEpic,
);
